import React from 'react'
import { Icon, Tooltip, Whisper } from 'rsuite'

export default function InformationIncon({ message, iconColor, backgroundColor, color, ...props }) {
  if (message) {
    return (
      <Whisper
        placement="top"
        trigger="hover"
        speaker={
          <Tooltip
            children={
              backgroundColor && color ? (
                <p style={{ backgroundColor: backgroundColor, color: color }}>{message}</p>
              ) : (
                message
              )
            }
          />
        }
      >
        <Icon
          icon="info"
          style={{ marginLeft: 5, marginRight: 5, color: iconColor || undefined }}
        />
      </Whisper>
    )
  }

  return null
}
